
const SOURCE_APP = 3; //fleet

module.exports = {
    SOURCE_APP
};
